import { render } from "./MoviePreview.vue?vue&type=template&id=25f41a6e&scoped=true&bindings={\"id\":\"props\",\"showModal\":\"data\",\"movie\":\"data\",\"updateMovie\":\"options\",\"deleteMovie\":\"options\"}"
import script from "./MoviePreview.vue?vue&type=script&lang=js"
export * from "./MoviePreview.vue?vue&type=script&lang=js"

import "./MoviePreview.vue?vue&type=style&index=0&id=25f41a6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25f41a6e"

export default script